module.exports = __webpack_public_path__ + "static/media/Detroit_Red_Wings.f662ee9e.svg";